var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-bottom-padding"},_vm._l((_vm.activities),function(activity){return _c('div',{key:activity.id},[_c('activity-item',{attrs:{"activity":activity}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }